









import Vue from "vue";
import DemoGuide from "@/components/DemoGuide.vue";
import NPMGuide from "@/components/NPMGuide.vue";

export default Vue.extend({
    components: {DemoGuide, NPMGuide},
});
